// for add employee state
export const ADD_EMPLOYEE_EXPERIENCE_DATA = "add_employee_experience_data";
